/*
 * Copyright (c) 2026 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, June 1st 2026, 2:55:09 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { getDefaultTaskTemplate } from "lib/factories";
import { EventConfiguration, EventDirection, TaskTemplate } from "lib/schemas";
import { EventConfigurationForm } from "./EventOchestrationSettings";
import { useTaskTemplateAPIForm, useEventConfigurationAPIForm } from "service-builder/services";
import { DropDownFormInput, FormSubmitBubblingStopper, OSAPIForm, OSActionButton } from "ui-widgets";
import { useServiceBuilderContext } from "service-builder/providers";

interface EventTaskTypeSelectorProps {
  saveNewTaskInfo: (optionalProperties: Partial<TaskTemplate>) => void;
}

export const EventTaskTypeSelector = ({ saveNewTaskInfo }: EventTaskTypeSelectorProps) => {
  const {
    processDefinitionContext: { currentProcessDefinition },
  } = useServiceBuilderContext();
  const useTaskTemplateAPIFormReturn = useTaskTemplateAPIForm(
    null,
    getDefaultTaskTemplate({
      processDefinition: currentProcessDefinition,
      bpmnNodeType: "Event",
      defaultSequence: 0,
    }) as any,
    () => {}
  );

  const onUpdateEventConfiguration = (eventConfiguration: EventConfiguration) => {
    saveNewTaskInfo({ event_configuration: eventConfiguration.id });
  };

  const useEventConfigurationAPIFormReturn = useEventConfigurationAPIForm({
    eventConfigurationId: null,
    eventConfiguration: {
      artifact_org: currentProcessDefinition.artifact_org,
      event_code: null,
      title: "New Event Config",
      event_direction: null,
    },
    onUpdateEventConfiguration,
  });

  const onConfirmCode = () => {
    useEventConfigurationAPIFormReturn.submitAPIForm();
  };

  const resetForEventDirection = () => {
    useEventConfigurationAPIFormReturn.useFormReturn.setValue("event_code", null);
    useEventConfigurationAPIFormReturn.useFormReturn.setValue("event_type", null);
    useEventConfigurationAPIFormReturn.useFormReturn.setValue("configuration", {});
  };

  return (
    <OSAPIForm useAPIFormReturn={useTaskTemplateAPIFormReturn} showSubmitButton={false}>
      <DropDownFormInput<TaskTemplate>
        schema_field_key="event_direction"
        label="Event Direction"
        options={EventDirection}
        onChange={(event) => {
          useEventConfigurationAPIFormReturn.useFormReturn.setValue("event_direction", event.target.value as any);
          resetForEventDirection();
        }}
      />
      <FormSubmitBubblingStopper>
        <EventConfigurationForm useAPIFormReturn={useEventConfigurationAPIFormReturn} showSubmitButton={false} />
      </FormSubmitBubblingStopper>
      <OSActionButton onClick={onConfirmCode} style={{ width: "100%" }} variant="contained">
        Continue
      </OSActionButton>
    </OSAPIForm>
  );
};
